import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import ObjectTypeName from 'automation-ui-references/object-types/ObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FormattedMessageWithSourceAndTargetObjectTypeNames({
  message,
  sourceObjectTypeId,
  targetObjectTypeId
}) {
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: message,
    options: {
      sourceObjectTypeName: /*#__PURE__*/_jsx(ObjectTypeName, {
        objectTypeId: sourceObjectTypeId,
        isCapitalized: false,
        isPlural: false
      }),
      sourceObjectTypeNamePlural: /*#__PURE__*/_jsx(ObjectTypeName, {
        objectTypeId: sourceObjectTypeId,
        isCapitalized: false,
        isPlural: true
      }),
      sourceObjectTypeNameCapitalized: /*#__PURE__*/_jsx(ObjectTypeName, {
        objectTypeId: sourceObjectTypeId,
        isCapitalized: true,
        isPlural: false
      }),
      sourceObjectTypeNamePluralAndCapitalized: /*#__PURE__*/_jsx(ObjectTypeName, {
        objectTypeId: sourceObjectTypeId,
        isCapitalized: true,
        isPlural: true
      }),
      targetObjectTypeName: /*#__PURE__*/_jsx(ObjectTypeName, {
        objectTypeId: targetObjectTypeId,
        isCapitalized: false,
        isPlural: false
      }),
      targetObjectTypeNamePlural: /*#__PURE__*/_jsx(ObjectTypeName, {
        objectTypeId: targetObjectTypeId,
        isCapitalized: false,
        isPlural: true
      }),
      targetObjectTypeNameCapitalized: /*#__PURE__*/_jsx(ObjectTypeName, {
        objectTypeId: targetObjectTypeId,
        isCapitalized: true,
        isPlural: false
      }),
      targetObjectTypeNamePluralAndCapitalized: /*#__PURE__*/_jsx(ObjectTypeName, {
        objectTypeId: targetObjectTypeId,
        isCapitalized: true,
        isPlural: true
      })
    }
  });
}